import {
  Brand,
  PopulatedTaxonomy,
  Colorway,
  TechpackImage,
  Techpack,
  CustomFieldValue,
  ReportFilters,
  SizeSpec,
  Creator,
  FullImage,
  Image,
  SwatchData,
  SourceFile,
  NewSwatch,
  Palette
} from './index'

export interface Product {
  _id: string
  name: string
  brand?: Brand
  company: string
  year?: PopulatedTaxonomy
  division?: PopulatedTaxonomy
  season?: PopulatedTaxonomy
  created_by: Creator
  createdAt: Date
  updatedAt?: Date
  description?: string
  code: string
  colorways?: Array<Colorway>
  variants?: Array<ProductVariant>
  category?: PopulatedTaxonomy
  techpack_images?: Array<TechpackImage>
  default_image?: Image
  price?: number
  price_unit?: string
  files?: Array<string>
  canceled: boolean
  custom_fields: Array<CustomFieldValue>
  __copiedFrom?: string
  bom_items?: Array<string>
  bom_dividers?: Array<string>
  techpacks?: Array<Techpack>
  hidden_bom_colorways?: Array<Colorway>
  hide_bom_pricing: boolean
  hide_bom_quantity: boolean
  hide_bom_notes: boolean
  hide_bom_placement: boolean
  samples: ProductSample
  size_spec?: SizeSpec
  selected?: boolean
}

export interface ProductSample {
  sampling: boolean
  sample_data: Array<string>
}

export interface ProductResponse {
  results: Array<Product>
  limit: number
  skip: number
  total: number
}

export interface ApiFilters {
  query?: string
  limit: number
  skip: number
  filters?: ReportFilters
  sort?: ProductSortOptions
}

export interface ProductImage {
  sections: string[]
  image: FullImage
}
export interface VariantImage {
  _id?: string
  url: string
  url_lo: string
  name: string
  front_page?: string
  sections: Array<string>
  caption: string
  createdAt: string
  isArchived: boolean
  is_archived: boolean
  sourceFile?: SourceFile
  position: number
}
export interface ProductVariant {
  _id?: string
  name?: string
  code?: string
  images?: Array<VariantImage> | Array<string>
  color?: SwatchData | string
  custom_fields?: Array<CustomFieldSelection | { field_info: string; value: any; type?: string }>
  created_by: string
  updated_by?: string
  createdAt?: string
  updatedAt?: string
  deactivatedAt?: string | null
}

export interface SimpleProductVariant extends Omit<ProductVariant, 'color'> {
  color: string
}

export interface NewProductVariant {
  name: string
  code?: string
  images?: Array<VariantImage>
  color?: NewSwatch | string
  custom_fields?: Array<CustomFieldSelection>
}

export interface CustomFieldSelection {
  field_info: { name?: string; _id: string }
  value: any
  type?: string
}

export enum ProductSortOptions {
  name_asc = 'name_asc',
  name_desc = 'name_desc',
  code_asc = 'code_asc',
  code_desc = 'code_desc',
  updated_at_asc = 'updatedAt_asc',
  updated_at_desc = 'updatedAt_desc',
  created_at_asc = 'createdAt_asc',
  created_at_desc = 'createdAt_desc'
}

export type activeVariantFiler = 'All' | 'Active' | 'Inactive'
